import React from "react";
import {
  FaDiscord,
  FaHeadphones,
  FaPlayCircle,
  FaSignal,
  FaUsers,
  FaVideo
} from "react-icons/fa";
import SEO from "../SEO";
import GameShowcasePage from "../GameShowcasePage";
import ghostCover from "../../images/ghost_hunter_carousel_1600x1400.webp";
import teaserVideo from "../../videos/ghost_hunter_home_page.mp4";
import homeMusic from "../../musics/home_music.mp3";

const DISCORD_URL = "https://discord.gg/sFxWsn4ruU";

const ghostMediaCard = (
  <section className="game-showcase__media-card">
    <p className="game-showcase__section-kicker">Teaser</p>
    <h2>Guarda il tono del gioco</h2>
    <div className="game-showcase__media-frame">
      <video controls preload="metadata" poster={ghostCover}>
        <source src={teaserVideo} type="video/mp4" />
      </video>
    </div>
    <p className="game-showcase__media-copy">
      Il video mostra l'atmosfera che stiamo cercando: indizi, tensione e luoghi che non sembrano mai del tutto fermi.
    </p>
    <div className="game-showcase__audio-card">
      <div className="game-showcase__audio-heading">
        <FaHeadphones aria-hidden="true" />
        <span>Audio</span>
      </div>
      <audio controls preload="none">
        <source src={homeMusic} type="audio/mpeg" />
      </audio>
    </div>
  </section>
);

const ghostLeaderboardPanel = (
  <section className="game-showcase__placeholder-board" aria-label="Classifica Ghost Hunter in arrivo">
    <p className="game-showcase__section-kicker">Non ancora attiva</p>
    <h2>La classifica arriverà con i playtest</h2>
    <p>
      Ghost Hunter non ha ancora una leaderboard pubblica. La useremo quando i test saranno abbastanza stabili
      da confrontare partite, squadre e risultati.
    </p>
    <div className="game-showcase__placeholder-metrics">
      <article className="game-showcase__placeholder-metric">
        <h3>Casi risolti</h3>
        <p>Quanti contratti vengono chiusi senza perdere il controllo della caccia.</p>
      </article>
      <article className="game-showcase__placeholder-metric">
        <h3>Tempo di indagine</h3>
        <p>Quanto velocemente una squadra trova gli indizi giusti.</p>
      </article>
      <article className="game-showcase__placeholder-metric">
        <h3>Run pulite</h3>
        <p>Partite completate con pochi errori e buona coordinazione.</p>
      </article>
    </div>
    <a className="game-showcase__placeholder-note" href={DISCORD_URL} target="_blank" rel="noopener noreferrer">
      <FaDiscord aria-hidden="true" />
      <span>Segui i playtest su Discord</span>
    </a>
  </section>
);

const storyParagraphs = [
  "Ghost Hunter è ancora in lavorazione. L'idea è semplice: entrare in un luogo infestato, leggere gli indizi e capire quando è il momento di rischiare.",
  "Non è un prodotto pronto per l'acquisto. Per ora vogliamo mostrare il tono, raccogliere feedback e usare i playtest per capire cosa funziona davvero.",
  "Quando ci sarà una versione più stabile, questa pagina cambierà: più dettagli, requisiti, build e classifica. Fino ad allora, lo stato resta chiaro."
];

const features = [
  {
    title: "Indizi e tensione",
    description:
      "Il gioco gira intorno a segnali da leggere, scelte rapide e luoghi che reagiscono.",
    icon: FaVideo
  },
  {
    title: "Test di squadra",
    description:
      "Le prove migliori saranno quelle in cui i giocatori parlano, sbagliano e correggono insieme.",
    icon: FaUsers
  },
  {
    title: "Sviluppo aperto",
    description:
      "Per ora si segue su Discord. Non ci sono acquisto, download pubblico o promessa di release immediata.",
    icon: FaSignal
  }
];

const facts = [
  { label: "Stato", value: "In sviluppo" },
  { label: "Vendita", value: "Non disponibile" },
  { label: "Prossimo passo", value: "Playtest" },
  { label: "Dove seguirlo", value: "Discord Kyros" }
];

const GhostHunterHome = () => {
  return (
    <>
      <SEO
        title="Ghost Hunter | Kyros Games"
        description="Ghost Hunter è un progetto Kyros in sviluppo: teaser, stato playtest e classifica non ancora attiva."
        canonical="https://kyrosgames.com/games/ghost-hunter"
        image="https://kyrosgames.com/images/ghost_hunter_carousel_1920x1080.webp"
        imageAlt="Artwork di Ghost Hunter"
      />

      <GameShowcasePage
        theme="ghost"
        eyebrow="In sviluppo"
        title="Ghost Hunter"
        summary="Una caccia al soprannaturale ancora in test. Guarda il teaser, leggi lo stato del progetto e segui i prossimi playtest."
        cover={ghostCover}
        coverAlt="Artwork di Ghost Hunter"
        highlights={[
          "Non in vendita",
          "Playtest in arrivo",
          "Teaser disponibile"
        ]}
        primaryAction={{
          label: "Segui su Discord",
          href: DISCORD_URL,
          external: true,
          icon: FaDiscord
        }}
        secondaryAction={{
          label: "Vedi lo Store",
          to: "/store",
          icon: FaPlayCircle
        }}
        storyTitle="Non è ancora pronto, ed è giusto dirlo"
        storyParagraphs={storyParagraphs}
        features={features}
        facts={facts}
        mediaCard={ghostMediaCard}
        leaderboardLabel="Classifica"
        leaderboardPanel={ghostLeaderboardPanel}
      />
    </>
  );
};

export default GhostHunterHome;
